"use strict";
var list = document.querySelector(".gallery__list");
var largeImg = document.querySelector("#largeImg");
list.addEventListener("click", function(e) {
    e.preventDefault();
    if (e.target.tagName === "IMG") largeImg.src = e.target.closest("a").href;
    else if (e.target.tagName === "A") largeImg.src = e.target.href;
});

//# sourceMappingURL=index.ce5f8529.js.map
